import { useQuery } from '@tanstack/react-query';
import { fetchFundAccountPostings } from '../services/fundAccountPostings';
import type { FundAccountSelection, StatementPeriod } from '../types/dealerFundStatementPeriod.types';
import { openPeriodDay, periodKey } from '../utils/statementPeriod';
import { dealerKeys } from './useDealersQuery';

const STALE_MS = 30_000;
const SESSION_CACHE_MS = 30 * 60_000;

export function useFundAccountPostingsQuery(
    selection: FundAccountSelection,
    period: StatementPeriod,
    todayIso: string,
    trancode: string,
    page: number,
) {
    return useQuery({
        queryKey: dealerKeys.fundStatementPeriodRows(
            selection.sellingDealerId,
            selection.productId,
            periodKey(period),
            openPeriodDay(period, todayIso),
            trancode,
            page,
        ),
        queryFn: () => fetchFundAccountPostings(selection.sellingDealerId, selection.productId, trancode, period, page),
        retry: false,
        refetchOnWindowFocus: false,
        staleTime: STALE_MS,
        gcTime: SESSION_CACHE_MS,
    });
}
